import React, { Component } from 'react';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { ILoanAccountActivity } from '../../../interfaces';
import { Loader } from '../../common';

import Activity, { isRenderableActivity } from './Activity';

interface IProps {
  activities: ILoanAccountActivity[];
  loading?: boolean;
  onNoteDeleted: () => Promise<void>;
  // The API serves deleted notes either way, so showing them is a filter over what is already here
  showDeletedNotes?: boolean;
}

@autoBindMethods
@observer
class ActivityList extends Component<IProps> {
  private isVisible (activity: ILoanAccountActivity) {
    if (activity.deleted_at && !this.props.showDeletedNotes) { return false; }

    return isRenderableActivity(activity);
  }

  public render () {
    const { activities, loading, onNoteDeleted } = this.props
      // The store sorts oldest first, as the case activity store does; the feed reads newest first.
      // filter() copies, so reversing here can't disturb the array the caller handed us.
      , orderedActivities = activities.filter(this.isVisible).reverse()
      ;

    if (loading) {
      return <Loader className='bloc-loader loading-activities' />;
    }

    return (
      <div className='list-activities'>
        {orderedActivities.map(activity => (
          <div key={activity.id} className='activity-wrapper'>
            <Activity activity={activity} onNoteDeleted={onNoteDeleted} />
          </div>
        ))}
      </div>
    );
  }
}

export default ActivityList;
